import { $themeConfig } from '@themeConfig';
import app from '@/main';
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {
    SET_LANG(state, payload) {
      app.$i18n.locale = payload;
      localStorage.setItem('WR1_APP_I18N_LOCALE', payload);
    },
  },
  actions: {
    setLang({ commit }, payload) {
      commit('SET_LANG', payload);
    },
  },
};
